import React from "react";
import { useNavigate } from "react-router-dom";

const SECTION_STYLE = { marginBottom: "24px" };
const H2_STYLE = { fontSize: "16px", fontWeight: "800", color: "#14532d", margin: "0 0 8px" };
const P_STYLE = { fontSize: "14px", color: "#374151", lineHeight: "1.7", margin: "0 0 8px" };
const LI_STYLE = { fontSize: "14px", color: "#374151", lineHeight: "1.7", marginBottom: "4px" };

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", padding: "24px 16px" }}>
      <div style={{ background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", maxWidth: "760px", margin: "0 auto", padding: "36px 32px" }}>
        <button onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", color: "#2563eb", fontSize: "13px", fontWeight: "600", cursor: "pointer", padding: 0, marginBottom: "20px" }}>
          ← Back
        </button>

        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ width: "56px", height: "56px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "24px" }}>⛳</div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#14532d" }}>Privacy Policy</h1>
          <p style={{ margin: "6px 0 0", fontSize: "13px", color: "#6b7280" }}>Golf Society Manager — last updated 3 September 2026</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Who we are</h2>
          <p style={P_STYLE}>Golf Society Manager ("GSM", "we", "us") is operated by Michael Sellman, trading as Golf Society Manager, and provides a web application (golfsocietymanager.com) and companion desktop application used by golf societies to manage members, competitions, scores and results. We are registered with the UK Information Commissioner's Office, registration reference <strong>ZC176881</strong>.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>What data we collect</h2>
          <p style={P_STYLE}>Depending on how you use GSM, we collect:</p>
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            <li style={LI_STYLE}>Name and email address, used to create and manage your account</li>
            <li style={LI_STYLE}>Golf handicap and club/society membership details</li>
            <li style={LI_STYLE}>Competition entries, scores, and results history</li>
            <li style={LI_STYLE}>A securely hashed password (we never store or can see your actual password)</li>
            <li style={LI_STYLE}>Basic technical data such as IP address and browser type, collected automatically for security and diagnostic purposes</li>
          </ul>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Why we process this data</h2>
          <p style={P_STYLE}>We process your data to provide the core service you or your golf society have signed up for: running competitions, calculating results, tracking handicaps and statistics, and enabling you to view and verify your own scores. This is processed on the basis of contract (providing the service you've requested) and, for the society organiser's own account details, legitimate interest in operating the platform.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Who your data is shared with</h2>
          <p style={P_STYLE}>Your competition data is visible to the organiser and other members of your own golf society only. It is never shared with other societies on the platform, sold to third parties, or used for advertising. We use the following processors to help operate the service:</p>
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            <li style={LI_STYLE}>Namecheap, our VPS hosting provider (physically located in the United States), to run the application and database</li>
            <li style={LI_STYLE}>Zoho, to send account and notification emails (hosted within the EU)</li>
            <li style={LI_STYLE}>Anthropic (Claude API), used for optional AI-assisted features an organiser can choose to use: reading a photo of a course's own scorecard to set up hole-by-hole par and stroke index (course layout facts only, no player data involved), checking entered scores for likely data-entry errors, tidying up an imported player spreadsheet, and voice-to-text player entry. Only the specific data needed for that feature is sent, never full account data</li>
          </ul>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>How long we keep your data</h2>
          <p style={P_STYLE}>We retain account and competition data for as long as your society's account remains active, so that historical results and statistics remain available. If a society or player account is closed, personal data is deleted within 30 days, except where we are required to retain it for legal or accounting reasons.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>How we protect your data</h2>
          <p style={P_STYLE}>All connections to GSM are encrypted using HTTPS/TLS. Passwords are hashed using bcrypt and are never stored in plain text. The production database is backed up nightly, with an additional physically disconnected ("air-gapped") backup copy rotated off-site, so that your society's data can be recovered even in the event of a serious incident such as ransomware. Full technical detail is available in our Security Methodology document (GSM-SEC-002) on request.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Cookies</h2>
          <p style={P_STYLE}>GSM uses only strictly necessary cookies/local storage required to keep you signed in and remember your preferences. We do not use advertising or third-party tracking cookies.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Your rights</h2>
          <p style={P_STYLE}>Under UK GDPR, you have the right to access, correct, or request deletion of your personal data, and to object to or restrict certain processing. To exercise any of these rights, or if you have a concern about how your data is handled, contact us using the details below. You also have the right to complain to the ICO at ico.org.uk if you believe your data has been mishandled.</p>
        </div>

        <div style={SECTION_STYLE}>
          <h2 style={H2_STYLE}>Contact</h2>
          <p style={P_STYLE}>For any question about this policy or your data, contact Michael Sellman, Golf Society Manager, via the email address associated with your society's account, or through the contact details provided on golfsocietymanager.com.</p>
        </div>

        <p style={{ textAlign: "center", fontSize: "11px", color: "#9ca3af", marginTop: "32px" }}>
          © 2026 Michael Sellman. Golf Society Manager. All rights reserved. · ICO Registration: ZC176881
        </p>
      </div>
    </div>
  );
}
